// The app renders at 75% CSS zoom: clientX and getBoundingClientRect are painted pixels, while scrollLeft,
// offsetWidth and our maths are layout pixels. Mixing them misplaces drag-created stops.

/** Layout pixels per painted pixel, measured off the element so nested zooms stay correct. */
export function layoutPixelScale(el: Element | null | undefined): number {
  if (!el) return 1

  const cssZoom = (el as Element & { currentCSSZoom?: number }).currentCSSZoom
  if (typeof cssZoom === "number" && cssZoom > 0) return 1 / cssZoom

  // offsetWidth is layout, the rect is painted; both are zero when unrendered.
  const painted = el.getBoundingClientRect().width
  const layout = (el as HTMLElement).offsetWidth
  if (!painted || !layout) return 1
  return layout / painted
}

/** Pointer offset from the element's left edge, in layout pixels. */
export function layoutOffsetX(el: Element, clientX: number): number {
  return (clientX - el.getBoundingClientRect().left) * layoutPixelScale(el)
}
